import { useProcess, useProcessState } from '~/store'
import { organizationBillingModule } from './organization-billing-module'

export function useOrganizationBilling(organizationId: string) {
  const organizationBilling = useProcess(organizationBillingModule, { organizationId })
  const organizationBillingState = useProcessState(organizationBillingModule, (s) => s)

  return [organizationBillingState, organizationBilling.send] as const
}
